import { Field, Input } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { ApiCustomer } from '@vend/types'
import { ContactNumber } from '../../../../../react/modals/common/ContactNumber'
import { CONTACT_OPTIONS } from '../../../../../react/modals/common/types'
import { getDefaultContactOption } from '../../../../../react/modals/common/customer-contact-utils'

const TContext = 'Line item fulfilment popover'

export type LineItemFulfilmentCustomerContactViewProps = {
  customer: ApiCustomer | null
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
}
export const LineItemFulfilmentCustomerContactView: React.FC<LineItemFulfilmentCustomerContactViewProps> = ({
  customer,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
}: LineItemFulfilmentCustomerContactViewProps) => {
  const t = useT()

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-6">
        <Field
          size="small"
          labelSlot={t('Contact number', { _context: TContext })}
        >
          <ContactNumber
            customer={customer}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onPhoneNumberChange(event.target.name, event.target.value)
            }}
            defaultOption={getDefaultContactOption(customer)}
          />
        </Field>
        <Field
          invalid={isEmailInvalid}
          size="small"
          labelSlot={t('Email', { _context: TContext })}
          errorMessageSlot={
            isEmailInvalid
              ? t('Enter a valid email address', {
                  _context: 'Error message for customer step in service modal.',
                })
              : undefined
          }
        >
          <Input
            type="email"
            placeholder={t('Enter email', { _context: TContext })}
            onChange={onEmailChange}
            name={CONTACT_OPTIONS.EMAIL}
            value={customer?.email || ''}
            size="small"
          />
        </Field>
      </div>
    </div>
  )
}
